import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Footer from 'components/layout/footer/Footer';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { useI18n } from 'hooks/useI18n';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import ServiceEventTracking from 'services/service.event-tracking';
import { createGlobalStyle } from 'styled-components';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { LOGO_MANFRED_WHITE } from 'utils/logos';
import {
  StyledFooter,
  StyledFooterContainer,
  StyledFooterCta,
  StyledFooterLogo
} from './StateOfTheSectorFooter.styled';

const GlobalStyle = createGlobalStyle<{ footerHeight: number }>`
  body {
    padding-bottom: ${(props) =>
      props.footerHeight ? props.footerHeight + 'px !important' : ''};
  }

  @media (max-height: ${(props) => props.footerHeight + 'px'}) {
    body {
      padding-bottom: 0 !important;
    }
    .main-footer {
      position: static !important;
    }
  }
`;

const StateOfTheSectorFooter = () => {
  const { locale } = useRouter();
  const [height, setHeight] = useState(0);
  const footerRef = useRef<HTMLElement>(null);

  const { t } = useI18n('state-of-the-sector');

  function footerHeight(): void {
    if (footerRef?.current) {
      setHeight(footerRef.current.clientHeight);
    }
  }

  useEffect(() => {
    footerHeight();

    const triggerEvent = isMobile ? 'orientationchange' : 'resize';

    window.addEventListener(triggerEvent, footerHeight);

    return () => {
      window.removeEventListener(triggerEvent, footerHeight);
    };
  }, []);

  return (
    <>
      <GlobalStyle footerHeight={height} />
      <StyledFooter ref={footerRef} className={`main-footer`}>
        <StyledFooterContainer>
          <StyledFooterLogo>
            <img
              src={LOGO_MANFRED_WHITE}
              alt="Manfred logo"
              width="132"
              height="24"
            />
            <p>{t('footer.claim')}</p>
          </StyledFooterLogo>
          <StyledFooterCta>
            <Link
              href={`${getAppUrl(
                APP_URLS.join,
                locale
              )}?locale=${locale}&source=footer-career-report`}
              passHref
            >
              <ButtonLink
                variant="brandTalent"
                onClick={(e) =>
                  ServiceEventTracking.trackExternalLandingCtaClicked(
                    e,
                    `${getAppUrl(
                      APP_URLS.join,
                      locale
                    )}?locale=${locale}&source=footer-career-report`,
                    'footer-career-report'
                  )
                }
              >
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>{t('footer.cta')}</span>
              </ButtonLink>
            </Link>
          </StyledFooterCta>
        </StyledFooterContainer>
        <Footer isInCustomFooter />
      </StyledFooter>
    </>
  );
};

export default StateOfTheSectorFooter;
